import { IS_ELECTRON } from '../../utils/config'

// 表示 在 electron 中运行，将会渲染， 浏览器中不会渲染
export function ElectronComponentShow({ children }) {
  if (IS_ELECTRON) {
    return children
  }
  return null
}

//  表示 在 electron 中运行，将不会渲染，浏览器中运行则会渲染
export function ElectronComponentHide({ children }) {
  if (IS_ELECTRON) {
    return null
  }
  return children
}
